import React from "react";
import LoadingCercle from "../assets/images/loadingCercle.gif";
import useCustomStyles from "../hooks/useCustomStyles";
import { customStyles } from "../assets/styles/CustomButtonStyles";
//import { Theme} from '../types';
import { useSelector } from "react-redux";
import { selectState } from "../store/slices/themeSlice";
import clsx from "clsx";

// Define the props interface for the component
interface CustomButtonProps {
  title: string;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  name: string;
  loading: boolean;
  disabled?: boolean; // disabled is optional
  type?: "submit" | "button" | "reset" | undefined;
  variant?: "primary" | "secondary" | "danger" ;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  title,
  handleClick,
  name,
  loading,
  disabled = false, // default value for disabled is false
  type,
  variant = "primary",
}) => {
  const { theme } = useSelector(selectState);
  const classes = useCustomStyles(customStyles, theme);

  return (
    <button
      name={name}
      type={type}
      //style={loading? styles.loadingButton : styles.button}
      className={
        variant === 'primary'
          ? classes.customButton
          : variant === 'secondary'
          ? classes.outlinedButton
          : classes.deleteButton
      }
      onClick={handleClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <img 
        className="loadingIcon" src={LoadingCercle} alt="loadingGif" />
      ) : (
        title
      )}
    </button>
  );
 
};

export default CustomButton;
